import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconEmail = (props) => /* @__PURE__ */ _jsx("svg", {
	"data-name": "Icon - Email",
	xmlns: "http://www.w3.org/2000/svg",
	width: 22.594,
	height: 22.593,
	viewBox: "0 0 22.594 22.593",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		"data-name": "Group 2121",
		children: [
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 5422",
				d: "M10.594 16.218a5.625 5.625 0 1 0 5.625-5.625 5.624 5.624 0 0 0-5.625 5.625",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("line", {
				"data-name": "Line 827",
				x2: 5.625,
				transform: "translate(13.406 16.218)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("line", {
				"data-name": "Line 828",
				x1: 2.109,
				y2: 2.109,
				transform: "translate(16.922 16.218)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("line", {
				"data-name": "Line 829",
				x1: 2.109,
				y1: 2.109,
				transform: "translate(16.922 14.109)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 5423",
				d: "M7.781 14.812H2.156A1.405 1.405 0 0 1 .75 13.406V2.156A1.405 1.405 0 0 1 2.156.75h16.875a1.405 1.405 0 0 1 1.406 1.406v6.326",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 5424",
				d: "m20.119 1.263-7.635 5.874a3.1 3.1 0 0 1-3.781 0L1.068 1.263",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	})
});
export { SvgIconEmail as ReactComponent };
